import { type TeamLevel, type TeamData, type TeamId, type CompanyData, isNotEmpty } from '@terros/common'
import { type MappedTeams } from '../types'
import { getLevelVisibleTeams, sortTeams, toDirectChildMap } from './sortTeams'

/**
 * Processes teams into hierarchical levels
 */
export const processTeamLevels = (teams: TeamData[], collapsedTeams: TeamId[], company: CompanyData): MappedTeams => {
  const collapsed = new Set(collapsedTeams)

  const highestLevel = company?.highestTeamLevel ?? 1
  const lowestLevel = company.lowestTeamLevel ?? 1
  const directChildMap = toDirectChildMap(teams)

  const levels = new Map<TeamLevel, TeamData[]>(
    Array.from({ length: highestLevel - lowestLevel + 1 }, (_, i) => [highestLevel - i, []])
  )
  if (!teams.length) return levels

  for (let level = highestLevel; level >= lowestLevel; level--) {
    const visibleTeamsAtLevel = getLevelVisibleTeams(teams, level, collapsed)

    if (isNotEmpty(visibleTeamsAtLevel)) {
      const parentTeams = getTeamsAtLevel(levels, level + 1)
      const sortedTeams = sortTeams(visibleTeamsAtLevel, parentTeams, directChildMap)
      levels.set(level, sortedTeams)
    }
  }

  return levels
}

const getTeamsAtLevel = (levels: Map<TeamLevel, TeamData[]>, level: TeamLevel | number): TeamData[] => {
  return levels.get(level as TeamLevel) ?? []
}
